import { arrayMove } from "react-sortable-hoc";
import { pasteMultiSelectedComps } from "../../Pages/multiCompSelect";

export const useEditorCanvasInteractions = ({
  multiSelectedComps,
  setCopiedComponent,
  editComponent,
  tempLayerScrollbarItems,
  tempLayer,
  tempSelect,
  setVisibility,
  layerCompData,
  setCount,
  setShowPaste,
  setLayerCompData,
  copiedComponent,
  count,
  countZindex,
  setMultiSelectedComps,
  imageOnCanvas,
  setSelectedComponent,
  selectedComponent,
  setScrollbarItems,
  selectedComponentState,
  containerID,
}) => {
  const copyCanvasComponent = () => {
    if (multiSelectedComps.length > 1) setCopiedComponent(multiSelectedComps);
    else {
      let data = [...(editComponent ? tempLayerScrollbarItems.current : tempLayer.current)];

      if (data && tempSelect) {
        let selectCompObj = { ...tempSelect.current };
        setCopiedComponent(selectCompObj);
      }
      setVisibility(false);
    }
  };

  const pasteComponentOnCanvas = (mm) => {
    let tempScrollbarComponents = layerCompData.find(
      (component) => component.id === editComponent?.id,
    )?.scrollbarComponents;
    if (copiedComponent.length >= 1)
      pasteMultiSelectedComps(
        count,
        setCount,
        setShowPaste,
        setVisibility,
        layerCompData,
        setLayerCompData,
        copiedComponent,
        countZindex,
        multiSelectedComps,
        setMultiSelectedComps,
        mm,
        imageOnCanvas,
        setSelectedComponent,
        selectedComponent,
      );
    else {
      if (copiedComponent) {
        pasteMultiSelectedComps(
          count,
          setCount,
          setShowPaste,
          setVisibility,
          editComponent ? tempScrollbarComponents : layerCompData,
          editComponent ? setScrollbarItems : setLayerCompData,
          [copiedComponent],
          countZindex,
          multiSelectedComps,
          setMultiSelectedComps,
          mm,
          imageOnCanvas,
          setSelectedComponent,
          selectedComponent,
        );
      }
    }
  };

  const updateZindexValue = (e, type) => {
    let tempScrollbarComponents = layerCompData?.find(
      (component) => component?.id === editComponent?.id,
    )?.scrollbarComponents;

    const currentLayers = editComponent ? tempScrollbarComponents : layerCompData;
    if (!Array.isArray(currentLayers) || currentLayers.length === 0) {
      setVisibility(false);
      return;
    }

    const selectedId =
      selectedComponentState && typeof selectedComponentState === "object"
        ? selectedComponentState.id || containerID
        : undefined;
    if (!selectedId) {
      setVisibility(false);
      return;
    }

    const indexSelected = currentLayers.findIndex(
      (layerObj) => layerObj?.id === selectedId,
    );
    if (indexSelected < 0 || !currentLayers[indexSelected]?.componentStyles) {
      setVisibility(false);
      return;
    }

    const orderedByZIndex = currentLayers
      .map((layerObj, originalIndex) => ({
        layerObj,
        originalIndex,
        zIndex: Number(layerObj?.componentStyles?.zIndex) || 0,
      }))
      .sort((a, b) => {
        if (b.zIndex !== a.zIndex) return b.zIndex - a.zIndex;
        return a.originalIndex - b.originalIndex;
      });

    const orderedSelectedIndex = orderedByZIndex.findIndex(
      (entry) => entry.layerObj?.id === selectedId,
    );
    if (orderedSelectedIndex < 0) {
      setVisibility(false);
      return;
    }

    const getTargetIndex = () => {
      switch (type) {
        case "Back":
          return orderedByZIndex.length - 1;
        case "Front":
          return 0;
        case "Backward":
          return Math.min(orderedSelectedIndex + 1, orderedByZIndex.length - 1);
        case "Forward":
          return Math.max(orderedSelectedIndex - 1, 0);
        default:
          return orderedSelectedIndex;
      }
    };

    const targetIndex = getTargetIndex();
    let reorderedByZIndex = [...orderedByZIndex];
    if (targetIndex !== orderedSelectedIndex) {
      reorderedByZIndex = arrayMove(
        reorderedByZIndex,
        orderedSelectedIndex,
        targetIndex,
      );
    }

    const nextZIndexById = new Map();
    reorderedByZIndex.forEach((entry, index) => {
      if (entry?.layerObj?.id) {
        nextZIndexById.set(entry.layerObj.id, reorderedByZIndex.length - index);
      }
    });

    const swappedLayerCompData = currentLayers.map((layerObj) => {
      const nextZIndex = nextZIndexById.get(layerObj?.id);
      if (nextZIndex === undefined || !layerObj || !layerObj.componentStyles) {
        return layerObj;
      }

      return {
        ...layerObj,
        componentStyles: {
          ...layerObj.componentStyles,
          zIndex: nextZIndex,
        },
      };
    });

    if (editComponent) {
      setScrollbarItems(swappedLayerCompData);
    } else {
      setLayerCompData(swappedLayerCompData);
    }
    setVisibility(false);
  };

  return {
    copyCanvasComponent,
    pasteComponentOnCanvas,
    updateZindexValue,
  };
};
